import './commercial.css'
import Container from 'react-bootstrap/Container'


export default function Commercial(){
    return(
        <div id="commercial-div">
        <h1 id="commercial-title">Partner With Us for Premium Local Greens</h1>
        <Container id="restaurant">
            <p className="restaurant-pargraph">
                If you run a restaurant or retail store searching for top-tier, reliable produce, you have 
                come to the right place. We grow directly to order so your kitchen or market shelves always 
                receive the freshest microgreens possible.
            </p>     

            
            <p className="restaurant-pargraph">
              Every order is hand-harvested and hand-packed, giving us a personal, quality-control check on every 
              single batch before it leaves our urban farm.
            </p>

            <h2 id="commercial-subheader">
                Why Partner With Holistic Green Things?
            </h2>
            <ul id="commercial-ul">
                <li>
                    <b>Zero-Soil Safety Standard:</b> We cultivate our microgreens using soil-free methods, eliminating the risk of 
                    contamination from fertilizers, soil pathogens, E.coli, or Listeria.
                </li>
                  <li>
                    <b>Year-Round Consistency:</b> Grown in a climate-controlled indoor environment, our crop yields remain stable and 
                    consistent across all seasons—free from pests and 100% pesticide-free.
                </li>
                  <li>
                    <b>100% Non-GMO Seeds:</b> We source non-GMO seeds exclusively, delivering pure, dense nutrition and vibrant flavor profiles.
                    
                </li>
                  <li>
                    <b>Tailored Delivery Schedules:</b> We respect the rhythm of commercial kitchens and retail spaces. We work around your schedule and guarantee 
                    deliveries will never occur during your busy lunch or dinner service.
                    
                </li>
                  <li>
                    <b>Flexible & Responsive Service:</b> We understand the natural ebbs and flows of the restaurant and retail industry. Need a specialized variety not 
                    listed in our current catalog? Reach out to us—we love collaborating with chefs and grocers to grow custom varieties for your menu or shelves.
                </li>
            </ul>
         
           
        </Container>

        
    </div>
    )
    
}